import { REGISTRATION_FLOW_TYPES } from '../constants';

export const isAipRegistrationFlow = (registrationFlowType) => {
  if (registrationFlowType === REGISTRATION_FLOW_TYPES.AIP) {
    return true;
  }

  return false;
};
